import { authHeader } from '../_helpers'
import httpClient from '../utils/http'
import moment from 'moment'
import { normalize, schema } from 'normalizr'
import _ from 'lodash'
import Chance from 'chance'
import { handleResponseAsync } from '../utils/HelperUtils'

import { viewConstants } from './../_constants/view.constants'
import { eventSchema } from './../entities/schema'

const chance = new Chance()

export const etimeService = {
    getAllETime,
    fetchETime,
    updateEvent,
    addEvent,
    removeEventById,
}

function convertViewModelList(data) {
    let viewModel = []
    if (!_.isEmpty(data) && _.isArray(data)) {
        data.map(o => {
            // Map preview format (Roster* fields) to expected format
            o.id = o.RosterAutoID || o.ID
            o.EmployeeName = o.EmployeeName
            o.Title = o.RosterDispTitle || o.Title || generateTitle(o)
            o.note = o.RosterNotes || o.Note || ''
            o.EmployeeID = o.RosterEmployeeID || o.EmployeeID
            o.CompanyID = o.RosterCompanyID || o.CompanyID
            o.source = o.source
            
            // Determine approval status from either RosterApproved (bool) or status string
            const isApproved = o.RosterApproved !== undefined ? o.RosterApproved : (o.Status === 'approved' || o.status === 'approved')
            o.draggable = !isApproved
            o.Status = isApproved ? 'approved' : 'draft'
            
            // Use startTime/endTime if available, otherwise reconstruct from date + time parts
            if (o.startTime) {
                o.start = moment(o.startTime).toDate()
            } else if (o.RosterDate && o.RosterStartTimeHour !== undefined) {
                const start = moment(o.RosterDate)
                start.hour(o.RosterStartTimeHour)
                start.minute(o.RosterStartTimeMinute || 0)
                o.start = start.toDate()
            } else {
                o.start = moment(o.StartDate).toDate()
            }
            
            if (o.endTime) {
                o.end = moment(o.endTime).toDate()
            } else if (o.RosterEndDate && o.RosterFinishTimeHour !== undefined) {
                const end = moment(o.RosterEndDate)
                end.hour(o.RosterFinishTimeHour)
                end.minute(o.RosterFinishTimeMinute || 0)
                o.end = end.toDate()
            } else {
                o.end = moment(o.EndDate).toDate()
            }
            
            // ActionType - default to 0 if not present
            o.ActionType = o.ActionType !== undefined ? o.ActionType : (o.PayrollEmpRosterActionTypeID || 0)
            
            // Break minutes
            o.break = o.Break !== undefined ? o.Break : (o.RosterBreakMinute || 0)
            
            // Clean up temporary fields
            delete o._id
            delete o.StartDate
            delete o.EndDate
            delete o.Note
            delete o.RosterDate
            delete o.RosterEndDate
            delete o.RosterStartTimeHour
            delete o.RosterStartTimeMinute
            delete o.RosterFinishTimeHour
            delete o.RosterFinishTimeMinute
            
            viewModel.push(o)
        })
    }

    const eventListSchema = [eventSchema]
    const normalizedData = normalize(viewModel, eventListSchema)
    return normalizedData.entities
}

// Generate a fallback title from time range if no title is provided
function generateTitle(o) {
    let title = '';
    if (o.startTime && o.endTime) {
        title = `${moment(o.startTime).format('HH:mm')} - ${moment(o.endTime).format('HH:mm')}`;
    } else if (o.RosterDate && o.RosterStartTimeHour !== undefined && o.RosterFinishTimeHour !== undefined) {
        const start = moment(o.RosterDate).hour(o.RosterStartTimeHour).minute(o.RosterStartTimeMinute || 0);
        const end = moment(o.RosterDate).hour(o.RosterFinishTimeHour).minute(o.RosterFinishTimeMinute || 0);
        title = `${start.format('HH:mm')} - ${end.format('HH:mm')}`;
    } else {
        title = 'Shift';
    }
    // Append employee name if available
    const employeeName = o.EmployeeName || '';
    return employeeName ? `${title} ${employeeName}` : title;
}

function convertViewModel(data) {
    if (!_.isEmpty(data)) {
        // Map preview format (Roster* fields) to expected format
        data.id = data.RosterAutoID || data.ID
        data.EmployeeName = data.EmployeeName
        data.Title = data.RosterDispTitle || data.Title || generateTitle(data)
        data.note = data.RosterNotes || data.Note || ''
        data.EmployeeID = data.RosterEmployeeID || data.EmployeeID
        data.CompanyID = data.RosterCompanyID || data.CompanyID
        data.source = data.source
        
        // Determine approval status from either RosterApproved (bool) or status string
        const isApproved = data.RosterApproved !== undefined ? data.RosterApproved : (data.Status === 'approved' || data.status === 'approved')
        data.draggable = !isApproved
        data.Status = isApproved ? 'approved' : 'draft'
        
        // Use startTime/endTime if available, otherwise reconstruct from date + time parts
        if (data.startTime) {
            data.start = moment(data.startTime).toDate()
        } else if (data.RosterDate && data.RosterStartTimeHour !== undefined) {
            const start = moment(data.RosterDate)
            start.hour(data.RosterStartTimeHour)
            start.minute(data.RosterStartTimeMinute || 0)
            data.start = start.toDate()
        } else {
            data.start = moment(data.StartDate).toDate()
        }
        
        if (data.endTime) {
            data.end = moment(data.endTime).toDate()
        } else if (data.RosterEndDate && data.RosterFinishTimeHour !== undefined) {
            const end = moment(data.RosterEndDate)
            end.hour(data.RosterFinishTimeHour)
            end.minute(data.RosterFinishTimeMinute || 0)
            data.end = end.toDate()
        } else {
            data.end = moment(data.EndDate).toDate()
        }
        
        // ActionType - default to 0 if not present
        data.ActionType = data.ActionType !== undefined ? data.ActionType : (data.PayrollEmpRosterActionTypeID || 0)
        
        // Break minutes
        data.break = data.Break !== undefined ? data.Break : (data.RosterBreakMinute || 0)

        delete data._id
        delete data.StartDate
        delete data.EndDate
        delete data.Note
        delete data.RosterDate
        delete data.RosterEndDate
        delete data.RosterStartTimeHour
        delete data.RosterStartTimeMinute
        delete data.RosterFinishTimeHour
        delete data.RosterFinishTimeMinute
    }

    const normalizedData = normalize(data, eventSchema)
    return normalizedData.entities
}

function convertById(data) {
    return data.ID
}

function castToModel(data) {
    const vm = {}
    // const _id = chance.guid();
    vm.ID = data.id || chance.guid()
    vm.Title = data.Title || data.title
    vm.StartDate = data.StartDate || data.start
    vm.EndDate = data.EndDate || data.end
    vm.ActionType = data.ActionType
    vm.ActionHours = data.ActionHours || data.duration
    vm.Note = data.note || ''
    vm.Break = _.toNumber(data.break) || 0.0
    vm.Status = 'edit'
    vm.EmployeeID = data.EmployeeID
    vm.CompanyID = data.CompanyID
    // vm.Status = data.note || '';
    // vm.Note = data.note || '';
    return vm
}

function castToModelNew(data) {
    const vm = {}
    // const _id = chance.guid();
    vm.ID = data.id || chance.guid()
    vm.Title = data.Title || data.title
    vm.StartDate = data.StartDate || data.start
    vm.EndDate = data.EndDate || data.end
    vm.ActionType = data.ActionType
    vm.ActionHours = data.ActionHours || data.duration
    vm.Note = data.note || ''
    vm.Break = _.toNumber(data.break) || 0.0
    vm.Status = 'edit'
    vm.EmployeeID = data.EmployeeID
    vm.CompanyID = data.CompanyID
    // vm.Status = data.note || '';
    // vm.Note = data.note || '';
    return vm
}

function getAllETime() {
    const url = '/api/etime/preview'

    return httpClient
        .get(url)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function fetchETime(options) {
    const url = '/api/etime/preview'

    const defaultQueryCond = {
        range: viewConstants.MONTH,
        time: new Date(),
    }

    let queryCond = options || defaultQueryCond

    // const config = {
    //     url: _url,
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    //     method: 'post',
    //     data: queryCond,
    // }

    return httpClient
        .post(url, queryCond)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function updateEvent(evt) {
    const url = '/api/etime'
    const payload = castToModel(evt)

    return httpClient
        .put(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data))
}

function addEvent(evt) {
    const url = '/api/etime'
    const payload = castToModelNew(evt)

    return httpClient
        .post(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data))
}

function removeEventById(evtId) {
    const url = `/api/etime/${evtId}`

    return httpClient
        .delete(url)
        .then(handleResponseAsync)
        .then(res => convertById(res.data))
}
